import { isNullOrUndefined } from '@weft/utils';
import React from 'react';
import { Spinner } from '../../../components/design/Spinner';
import { useContractPage } from '../../../hooks/requests/pages/use-contract-page';
import { useContractId } from '../../../hooks/use-contract-id';
import { ContractPageContentView } from './ContractPageContentView';

type ContractPageContentProps = {
  customerContractId: string | undefined;
};

export const ContractPageContent: React.FC<ContractPageContentProps> = ({ customerContractId }) => {
  const contractId = useContractId(customerContractId);
  const { data } = useContractPage(contractId);

  if (isNullOrUndefined(data)) {
    return <Spinner/>;
  }

  return (
    <ContractPageContentView contractPageData={data.contractPageData}/>
  );
};
